module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-2 mb-5"
  }, [_c('div', {
    staticClass: "search-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search for..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.search(_vm.searchTerm)
      }
    }
  }, [_vm._v("Search Boilerplates")])])]), _vm._v(" "), _c('div', {
    staticClass: "row tags mt-3",
    attrs: {
      "id": "tags"
    }
  }, [_c('ul', {
    staticClass: "col-sm-6 d-flex"
  }, [_c('span', {
    staticClass: "h5 mb-1"
  }, [_vm._v("Frameworks")]), _vm._v(" "), _vm._l((_vm.searchTags.frameworks), function(tag, index) {
    return _c('li', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchTagsSelected),
        expression: "searchTagsSelected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "name": "searchTagsSelected"
      },
      domProps: {
        "value": tag,
        "checked": Array.isArray(_vm.searchTagsSelected) ? _vm._i(_vm.searchTagsSelected, tag) > -1 : (_vm.searchTagsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.searchTagsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.searchTagsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.searchTagsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.searchTagsSelected = $$c
          }
        }, function($event) {
          return _vm.tagSearchTerm()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_vm._v(_vm._s(tag))])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "h5 mb-1 mt-3"
  }, [_vm._v("CMS")]), _vm._v(" "), _vm._l((_vm.searchTags.cms), function(tag, index) {
    return _c('li', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchTagsSelected),
        expression: "searchTagsSelected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "name": "searchTagsSelected"
      },
      domProps: {
        "value": tag,
        "checked": Array.isArray(_vm.searchTagsSelected) ? _vm._i(_vm.searchTagsSelected, tag) > -1 : (_vm.searchTagsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.searchTagsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.searchTagsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.searchTagsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.searchTagsSelected = $$c
          }
        }, function($event) {
          return _vm.tagSearchTerm()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_vm._v(_vm._s(tag))])])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "col-sm-6 d-flex"
  }, [_c('span', {
    staticClass: "h5 mb-1"
  }, [_vm._v("Testing")]), _vm._v(" "), _vm._l((_vm.searchTags.testing), function(tag, index) {
    return _c('li', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchTagsSelected),
        expression: "searchTagsSelected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "name": "searchTagsSelected"
      },
      domProps: {
        "value": tag,
        "checked": Array.isArray(_vm.searchTagsSelected) ? _vm._i(_vm.searchTagsSelected, tag) > -1 : (_vm.searchTagsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.searchTagsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.searchTagsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.searchTagsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.searchTagsSelected = $$c
          }
        }, function($event) {
          return _vm.tagSearchTerm()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_vm._v(_vm._s(tag))])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "h5 mb-1 mt-3"
  }, [_vm._v("Utilities")]), _vm._v(" "), _vm._l((_vm.searchTags.utilities), function(tag, index) {
    return _c('li', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchTagsSelected),
        expression: "searchTagsSelected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "name": "searchTagsSelected"
      },
      domProps: {
        "value": tag,
        "checked": Array.isArray(_vm.searchTagsSelected) ? _vm._i(_vm.searchTagsSelected, tag) > -1 : (_vm.searchTagsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.searchTagsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.searchTagsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.searchTagsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.searchTagsSelected = $$c
          }
        }, function($event) {
          return _vm.tagSearchTerm()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_vm._v(_vm._s(tag))])])])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showTags()
      }
    }
  }, [_vm._v(_vm._s(_vm.showTagsTxt))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 row justify-content-center",
    attrs: {
      "id": "searchResults"
    }
  }, [_c('loader', {
    attrs: {
      "isloading": _vm.isSearching
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearching),
      expression: "!isSearching"
    }]
  }, [_vm._l((_vm.searchResults), function(boilerplate, index) {
    return [_c('boilerplateitem', {
      staticClass: "col-12",
      attrs: {
        "itemdata": boilerplate,
        "type": 'search'
      }
    })]
  })], 2), _vm._v(" "), (_vm.noResults && !_vm.isSearching) ? _c('h3', [_vm._v("No boilerplates have been found for your search. Try something simpler.")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f76097b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/boilerplate-search.vue
// module id = 184
// module chunks = 1